import { render, staticRenderFns } from "./order-shipment-information.vue?vue&type=template&id=53b4961a&"
import script from "./order-shipment-information.vue?vue&type=script&lang=js&"
export * from "./order-shipment-information.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports